import { Box, Typography, Grid, TextField } from '@mui/material';
import { IDam } from '../../../services/api/dams/DamServices';

interface OperationalCharacteristicsProps  {
    data: IDam;
}


export const OperationalCharacteristics = ({data}: OperationalCharacteristicsProps) => {

    return(
        <Box padding={0}>
            <Box>
                <Typography variant='h5'>Características Operacionais</Typography>
            </Box>
            <Box padding={1} marginTop={0}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.processo_beneficiamento}
                            label='Processo de beneficiamento'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.produtos_quimicos}
                            label='Produtos químicos utilizados'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.mineral_presente_rejeito}
                            label='Mineral principal presente no rejeito'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.teor_mineral_rejeito}
                            label='Teor(%) do mineral principal do rejeito'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.teor_outros_mineral_rejeito}
                            label='Teor(%) de outros minerais presentes no rejeito'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.densidade_rejeito}
                            label='Densidade específica do rejeito (t/m³)'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.geracao_rejeito}
                            label='Geração de rejeito (t/mês)'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.teor_solidos_polpa}
                            label='Teor (%) de sólidos na polpa'
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};